import React from 'react';
import { Container } from 'react-bootstrap';
import '../styles/footer.css';

const Footer = () => {
	return (
		<Container>
			<footer className='footer-container'>
				
				<div  className='footer-copyright'>&copy;2022 Agrolinka</div>
			</footer>
		</Container>
	);
};

export default Footer;
